import Pagination from '@/util/pagination'
import { formatDate } from '@/util/helpers'

export default function () {
  return {
    filters: {
      'teacher.email': null,
      'teacher.name': null,
    },
    events: [],
    pagination: new Pagination(),
    formatDate,
  }
}
